import React, { useEffect } from 'react'
import { useImmer } from 'use-immer'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'

import Spinner from 'components/common/Spinner'
import { viewCollectionOverview } from 'store/collections/general/actions.js'
import SettingsMain from './general'
import SettingsTicketing from './ticketing/index'
import SettingsNotification from './notifications'
import SettingsSeedEntities from './seeds/index'
import SettingsCredentials from './credentials'

import RightArrowIcon from 'assets/chevron-right-gray.svg'

const domain = 'https://api.intrigue.io'
const CollectionSettings = (props) => {
    const isTablet = useMediaQuery({ maxWidth: 768 })

    const dispatch = useDispatch()
    const collectionName = props.match.params.id

    const history = useHistory()
    const [state, setState] = useImmer({
        selectedSettings: 'MAIN',
    })

    useEffect(() => {
        dispatch(viewCollectionOverview(collectionName))
    }, [])

    const viewCollectionState = useSelector(
        (state) => state.collection.generalSettings.overview
    )

    const SETTINGS_MENU = {
        MAIN: 'General',
        SEED_ENTITIES: 'Seed Entities',
        CREDENTIALS: 'Credentials',
        TICKETING: 'Ticketing',
        NOTIFICATIONS: 'Notifications',
    }

    const switchSettings = (value) => {
        setState((draft) => {
            draft.selectedSettings = value
        })
    }

    if (viewCollectionState.loading) {
        return (
            <div
                id="settings-renderer"
                className="mx-4 my-4 px-6 py-10 flex items-center justify-center"
            >
                <Spinner loaderSize="lg" />
            </div>
        )
    }

    const renderSettingsNavigation = () => {
        return Object.keys(SETTINGS_MENU).map((item, index) => (
            <React.Fragment key={index}>
                {isTablet ? (
                    <div
                        className={
                            state.selectedSettings === item
                                ? 'border border-primary-100 text-primary-400 bg-primary-100 rounded-md px-1 py-1 my-2 w-48 font-bold cursor-pointer text-md mx-2 text-center'
                                : 'text-gray-600 hover:bg-gray-200 rounded-md px-1 py-1 my-2 w-48 cursor-pointer text-md mx-2 text-center'
                        }
                        onClick={() => switchSettings(item)}
                    >
                        {SETTINGS_MENU[item]}
                    </div>
                ) : (
                    <div
                        className={
                            state.selectedSettings === item
                                ? 'border border-primary-100 text-primary-400 bg-primary-100 rounded-md px-4 py-1 my-2 w-48 font-bold cursor-pointer text-lg'
                                : 'text-gray-600 hover:bg-gray-200 rounded-md px-4 py-1 my-2 w-48 cursor-pointer text-lg'
                        }
                        onClick={() => switchSettings(item)}
                    >
                        {SETTINGS_MENU[item]}
                    </div>
                )}
            </React.Fragment>
        ))
    }

    const renderSettingsContent = () => {
        switch (state.selectedSettings) {
            case 'MAIN':
                return <SettingsMain {...props} />

            case 'CREDENTIALS':
                return <SettingsCredentials {...props} />

            case 'TICKETING':
                return <SettingsTicketing {...props} />

            case 'NOTIFICATIONS':
                return <SettingsNotification {...props} />

            case 'SEED_ENTITIES':
                return <SettingsSeedEntities {...props} />

            default:
                return <SettingsMain />
                break
        }
    }

    return (
        <React.Fragment>
            <div id="collection-settings-container" className="mt-24 w-full">
                <div className="flex flex-wrap w-full">
                    <div
                        className="w-full lg:w-3/12
          px-2 lg:px-5
          lg:fixed"
                    >
                        <div className="flex items-center flex-wrap w-full text-sm ">
                            <span
                                className="cursor-pointer px-2 py-1 font-bold text-primary-500 hover:bg-gray-200 rounded-md"
                                onClick={() => {
                                    history.push('/collections')
                                }}
                            >
                                Collections
                            </span>
                            <span className="ml-1">
                                <img
                                    width="20"
                                    height="20"
                                    src={RightArrowIcon}
                                />
                            </span>
                            <span className="ml-1 cursor-pointer px-2 py-1 font-bold text-primary-500 hover:bg-gray-200 rounded-md">
                                Settings
                            </span>
                            <span className="ml-1">
                                <img
                                    width="20"
                                    height="20"
                                    src={RightArrowIcon}
                                />
                            </span>
                            <span className="ml-1 cursor-pointer px-2 py-1 font-bold text-primary-500 hover:bg-gray-200 rounded-md">
                                {SETTINGS_MENU[state.selectedSettings]}
                            </span>
                        </div>
                        <div className="my-1 w-full text-left">
                            <div className="flex items-center px-2 py-2  w-auto">
                                <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gray-100">
                                    <img
                                        className="max-w-none opacity-05 p-1 w-16 h-16 rounded-50-percent inline-block border-2 border-gray-400 bg-gray-100 object-cover cursor-pointer"
                                        src={
                                            domain +
                                            viewCollectionState?.data
                                                ?.local_icon_path
                                        }
                                    />
                                </div>
                                <div className=" text-s font-bold py-2 px-4 ">
                                    {viewCollectionState?.data
                                        ?.printable_name || 'Loading ...'}
                                </div>
                            </div>
                        </div>
                        <div
                            className={`${
                                isTablet
                                    ? `mt-5 mb-10 flex items-center p-2 border-b border-gray-300 shadow-sm`
                                    : ``
                            }`}
                        >
                            {renderSettingsNavigation()}
                        </div>
                    </div>
                    <div
                        id="settings-renderer"
                        className="w-full lg:w-9/12 pr-4 lg:pr-10 pl-4 lg:pl-0"
                        style={isTablet ? {} : { marginLeft: '25%' }}
                    >
                        {renderSettingsContent()}{' '}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CollectionSettings
